import { render } from "./ms-sidebar-cart.vue?vue&type=template&id=323ae602&scoped=true"
import script from "./ms-sidebar-cart.vue?vue&type=script&lang=js"
export * from "./ms-sidebar-cart.vue?vue&type=script&lang=js"

import "./ms-sidebar-cart.vue?vue&type=style&index=0&id=323ae602&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\agco-ecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323ae602"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
